import { Oval } from "react-loader-spinner";

export default function Loader() {
    return <>
         <Oval
            visible={true}
            height="80"
            width="80"
            color="#24a3f2"
            secondaryColor="#a6ddff"
            ariaLabel="oval-loading"
            wrapperStyle={{}}
            wrapperClass=""
        />
    </>
}